export default __webpack_public_path__ + "static/media/signup-min.65c555fa.jpg";